import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { classExists } from "../helper/class-exists";

const cardSlider = () => {
  const elems = document.querySelectorAll(".js-card-slider");
  classExists(elems);

  elems.forEach(function (swiperClass) {
    const swiperSlides = swiperClass.querySelector(".card-list");
    let next = swiperClass.parentNode.querySelector(".swiper-button-next");
    let prev = swiperClass.parentNode.querySelector(".swiper-button-prev");
    let slidesCount = "auto";

    // let slideCount = swiperClass.dataset.slidesVisible;

    if (swiperSlides.classList.contains("is-three")) {
      slidesCount = 3;
    }

    if (swiperSlides.classList.contains("is-four")) {
      slidesCount = 4;
    }

    const swiper = new Swiper(swiperClass, {
      modules: [Navigation],
      slidesPerView: "auto",
      slideToClickedSlide: true,
      spaceBetween: 24,
      breakpoints: {
        1280: {
          slidesPerView: slidesCount,
        },
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  });
};

const cardSliderSwiperButtons = () => {
  const elems = document.querySelectorAll(".js-card-slider");
  classExists(elems);

  elems.forEach(function (swiperClass) {
    const next = swiperClass.parentNode.querySelector(".swiper-button-next");
    const prev = swiperClass.parentNode.querySelector(".swiper-button-prev");
    const buttonElem = swiperClass.parentNode.querySelector('.swiper-buttons');
    const buttonContainerElem = swiperClass.parentNode.querySelector('.title-swiper-navigation');

    if(next.classList.contains('swiper-button-lock') || prev.classList.contains('swiper-button-lock')) {
      buttonElem.classList.add('is-hidden');
      buttonContainerElem.classList.add('inactive-swiper-buttons');
    }
    else {
      buttonElem.classList.remove('is-hidden');
      buttonContainerElem.classList.remove('inactive-swiper-buttons');
    }
  })
}

document.addEventListener("DOMContentLoaded", function () {
  cardSlider();
  cardSliderSwiperButtons();
});

window.addEventListener(
  "resize",
  function (event) {
    cardSliderSwiperButtons();
  },
  true
);